import { render, staticRenderFns } from "./ImageCropper.vue?vue&type=template&id=453df2cf&scoped=true"
import script from "./ImageCropper.vue?vue&type=script&lang=js"
export * from "./ImageCropper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453df2cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('453df2cf')) {
      api.createRecord('453df2cf', component.options)
    } else {
      api.reload('453df2cf', component.options)
    }
    module.hot.accept("./ImageCropper.vue?vue&type=template&id=453df2cf&scoped=true", function () {
      api.rerender('453df2cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/ImageCropper.vue"
export default component.exports